const routes = {
    //------------------------
    //public routes
    //------------------------
    login: '/login',
    acceptInvite: '/accept-invite',
    auth: '/auth',
    signup: '/signup',
    passwordReset: '/password-reset',
    forgotPassword: '/forgot-password',
    requestEmail: '/request-email',
    //------------------------
    //private routes
    //------------------------
    selectOrganization: '/select-organization',
    dashboardRiskManagement: '/risk',
    riskManagement: '/risk-management',
    riskManagementform: '/risk-management/form/:categoryId',

    //------------------------
    //uncategorized
    //------------------------
    dashboard: '/',
    templates: '/templates',
    assetTypes: '/assets/types/explore',
    vulnerabilities: '/vulnerabilities',
    viewReportArtifact: '/view-report-artifact',
    initcypress: '/initcypress',
    event: '/events/:eventId',

    //------------------------
    //plan module
    //------------------------
    plan: '/plan',
    planSplash: '/plan/splash',
    playbooks: '/plan/playbooks',
    playbookMarketplace: '/plan/playbooks/marketplace',
    playbookDesigner: '/plan/playbook-designer',
    playbookDetails: '/plan/playbook-designer/:incidentTypeId',
    comms: '/plan/comms',
    raci: '/plan/raci',
    //------------------------
    //practice module
    //------------------------
    practice: '/practice',
    practiceSplash: '/practice/splash',
    simulations: '/practice/simulations',
    createSimulation: '/practice/create-simulation',
    editSimulation: '/practice/edit-simulation',
    simulationDetails: '/practice/simulations/:incidentId',
    simulationNewTask: '/practice/new-task/:incidentId/stage/:stageId',
    simulationTaskDetails: '/practice/simulations/:incidentId/tasks/:taskId',
    simulationArtifacts: '/practice/artifacts',
    simulationReports: '/practice/reports',
    simulationReportDetails: '/practice/reports/:incidentId',
    backstage: '/backstage',
    //------------------------
    //respond module
    //------------------------
    respond: '/respond',
    respondSplash: '/respond/splash',
    incidents: '/respond/incidents',
    createIncident: '/respond/create-incident',
    editIncident: '/respond/edit-incident',
    incidentDetails: '/respond/incidents/:incidentId',
    newTask: '/respond/new-task/:incidentId/stage/:stageId',
    taskDetails: '/respond/incidents/:incidentId/tasks/:taskId',
    artifacts: '/respond/artifacts',
    reports: '/respond/reports',
    reportDetails: '/respond/reports/:incidentId',
    //------------------------
    //monitor module
    //------------------------
    monitor: '/monitor',
    monitorSplash: '/monitor/splash',
    alert: '/monitor/alerts/:alertId',
    alertsByRuleId: '/monitor/alerts/by-rules/:ruleId',
    alertsByAssetId: '/monitor/alerts/by-assets/:assetId',
    alertsByGroupId: '/monitor/alerts/by-groups/:groupId',
    alertsByRules: '/monitor/alerts/by-rules',
    alertsByAssets: '/monitor/alerts/by-assets',
    alertsByGroups: '/monitor/alerts/by-groups',
    alerts: '/monitor/alerts',
    //------------------------
    //settings module
    //------------------------
    settings: '/settings',
    team: '/settings/team',
    addTeamMember: '/settings/team/add-team-member',
    editTeamMember: '/settings/team/edit-member/:userId',
    roles: '/settings/team/roles',
    assets: '/settings/assets',
    assetDetails: '/settings/assets/:assetId',
    billing: '/settings/billing',
    raciChart: '/settings/team/responsibilities',
    integrations: '/settings/integrations',
    addIntegrations: '/settings/integrations/add',

    /**
     * warning: donot use this route tree - this is only here as an artifact of the past
     */
    'legacy-routes': {
        login: '/login',
        acceptinvite: '/accept-invite',
        auth: '/auth',
        signup: '/signup',
        passwordReset: '/password-reset',
        forgotpassword: '/forgot-password',
        dashboard: '/',
        dashboardalerts: '/alerts',
        alert: '/alerts/:alertId',
        dashboardalertsbyrules: '/alerts/by-rules',
        dashboardalertsbyassets: '/alerts/by-assets',
        dashboardalertsbygroups: '/alerts/by-groups',
        dashboardalertsbyruleid: '/alerts/by-rules/:ruleId',
        dashboardalertsbyassetid: '/alerts/by-assets/:assetId',
        dashboardalertsbygroupid: '/alerts/by-groups/:groupId',
        dashboardalertscatchall: '/alerts/:groupType/:resourceId',
        dashboardriskmanagement: '/risk',
        team: '/team',
        roles: '/team/roles',
        simulations: '/simulations',
        createsimulation: '/simulations/create-simulation',
        simulationdetails: '/simulations/:incidentId',
        simulationtaskdetails: '/simulations/:incidentId/tasks/:taskId',
        simulationreportdetails: '/simulation-report/:incidentId',
        incidents: '/incidents',
        createincident: '/incidents/create-incident',
        incidentdetails: '/incidents/:incidentId',
        taskdetails: '/incidents/:incidentId/tasks/:taskId',
        newtask: '/new-task/:incidentId/stage/:stageId',
        templates: '/templates',
        reports: '/reports',
        settings: '/settings',
        backstage: '/backstage',
        addteammember: '/team/add-team-member',
        assets: '/assets',
        assettypes: '/assets/types/explore',
        assetdetails: '/assets/:assetId',
        vulnerabilities: '/vulnerabilities',
        artifacts: '/artifacts',
        editincident: '/edit-incident',
        editteammember: '/team/edit-member/:userId',
        viewreportartifact: '/view-report-artifact',
        playbooks: '/playbooks',
        playbookMarketplace: '/playbooks/marketplace',
        playbookdesigner: '/playbook-designer',
        playbookdetails: '/playbook-designer/:incidentTypeId',
        riskmanagement: '/risk-management',
        riskmanagementform: '/risk-management/form/:categoryId',
        selectorgnization: '/select-organization',
        managebilling: '/settings/manage-billing',
        managebilling2: '/manage-billing',
        requestemail: '/request-email',
        initcypress: '/initcypress',
        event: '/events/:eventId',
        racichart: '/team/responsibilities',
        integrations: '/integrations',
        addintegrations: '/integrations/add',
    },
}

export default routes
